import { render, staticRenderFns } from "./IndividualCenter.vue?vue&type=template&id=591d924e&scoped=true"
import script from "./IndividualCenter.vue?vue&type=script&lang=js"
export * from "./IndividualCenter.vue?vue&type=script&lang=js"
import style0 from "./IndividualCenter.vue?vue&type=style&index=0&id=591d924e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591d924e",
  null
  
)

export default component.exports